import React, { useState, useEffect } from 'react';
import styles from 'components/toast/index.module.scss';
import className from 'classnames/bind';

const cx = className.bind(styles);

const Toast = ({ isShow = true, children }) => {
  const [show, setShow] = useState(isShow);

  useEffect(() => {
    setTimeout(() => setShow(isShow), 500);
  }, [isShow]);

  useEffect(() => {
    if (show) {
      setTimeout(() => setShow(false), 3000);
    }
  }, [show]);

  const toastContainer = cx({
    toastContainer: true,
    show,
  });

  return (
    <div className={toastContainer}>
      <div className={styles.toast}>{children}</div>
    </div>
  );
};

export default Toast;
